/* App owns screen selection only; mounted screens own their visual layout. */
.contentCovered {
	pointer-events: none;
}
